<template>
  <v-app>
    <Header/>
    <v-container>
      <v-row>
        <v-col :cols="12" :md="12"><EmbeddedResult />
      <Reply />
      </v-col>
      </v-row>
      <v-row>
      <v-col :cols="12" :md="12"><Map/></v-col>
      </v-row>
    </v-container>
    <v-footer
    class="pt-6"
    color="rgb(255, 0, 0, 0)"
    >
    <v-col
      class="py-2 white--text text-center caption"
      cols="12"
    >
    <p class="caption">
    The website was created by <a target="_blank" class="white--text" href="https://www.andylee.tw">Yu-Hsun Lee</a> with support from <a target="_blank" class="white--text" href="http://www.tms.org.tw">Taiwan Mathematics Society</a>.
    <br>
    A project by the Mathematical Society of the Republic of China (Taiwan Mathematics Society) to celebrate the International Day of Mathematics led by the International Mathematics Union (IMU).
    </p>
    </v-col>
  </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/HeaderGlobal.vue'
import Map from '@/components/MapGlobal.vue'
import EmbeddedResult from "@/components/ResultGlobal.vue";
import Reply from "@/components/ReplyGlobal.vue";

export default {
  name: 'Home',
  components: {
    Header,
    Map,
    EmbeddedResult,
    Reply
  },
  mounted(){
      this.$vuetify.theme.dark = true;
  }
}
</script>